export enum VehicleCascoEnum {
  TOTAL = 'TOTAL',
  PARTIAL = 'PARTIAL',
  NONE = 'NONE',
}

export const getVehicleCascoEnumLabel = (value: VehicleCascoEnum): string => {
  switch (value) {
    case VehicleCascoEnum.TOTAL:
      return $localize`Casco complète`;
    case VehicleCascoEnum.PARTIAL:
      return $localize`Casco partielle`;
    case VehicleCascoEnum.NONE:
      return $localize`Aucune`;
    default:
      return '';
  }
};

export enum VehicleDistanceEnum {
  LESS_THAN_10000 = 'LESS_THAN_10000',
  BETWEEN_10000_AND_15000 = 'BETWEEN_10000_AND_15000',
  MORE_THAN_15000 = 'MORE_THAN_15000',
}

export const getVehicleDistanceLabel = (value: VehicleDistanceEnum): string => {
  switch (value) {
    case VehicleDistanceEnum.LESS_THAN_10000:
      return $localize`0 - 10 000 km`;
    case VehicleDistanceEnum.BETWEEN_10000_AND_15000:
      return $localize`10 000 - 15 000 km`;
    case VehicleDistanceEnum.MORE_THAN_15000:
      return $localize`Plus de 15 000 km`;
    default:
      return '';
  }
};

export enum VehicleGarageEnum {
  HOME = 'HOME',
  HOME_AND_WORKPLACE = 'HOME_AND_WORKPLACE',
  WORKPLACE = 'WORKPLACE',
  NONE = 'NONE',
}

export const getVehicleGarageLabel = (value: VehicleGarageEnum): string => {
  switch (value) {
    case VehicleGarageEnum.HOME:
      return $localize`Maison`;
    case VehicleGarageEnum.HOME_AND_WORKPLACE:
      return $localize`Maison et travail`;
    case VehicleGarageEnum.WORKPLACE:
      return $localize`Travail`;
    case VehicleGarageEnum.NONE:
      return $localize`Aucun des deux`;
    default:
      return '';
  }
};

export enum VehicleOfferTier {
  BASIC = 'BASIC',
  COMFORT = 'COMFORT',
  PREMIUM = 'PREMIUM',
}

export const getVehicleOfferTierLabel = (tier: VehicleOfferTier): string => {
  switch (tier) {
    case VehicleOfferTier.BASIC:
      return $localize`Basic`;
    case VehicleOfferTier.COMFORT:
      return $localize`Comfort`;
    case VehicleOfferTier.PREMIUM:
      return $localize`Premium`;
    default:
      return '';
  }
};

export enum VehiclePrestationsEnum {
  FREE_GARAGE_CHOICE = 'FREE_GARAGE_CHOICE',
  REPLACEMENT_VEHICLE = 'REPLACEMENT_VEHICLE',
  PERSONAL_BELONGINGS = 'PERSONAL_BELONGINGS',
  PASSENGERS_PROTECTION = 'PASSENGERS_PROTECTION',
  PARKING_DAMAGE = 'PARKING_DAMAGE',
  GROSS_NEGLIGENCE = 'GROSS_NEGLIGENCE',
  TROUBESHOOTING = 'TROUBESHOOTING',
  GLASS_PROTECTION = 'GLASS_PROTECTION',
  TIRES = 'TIRES',
}

export const getVehiclePrestationLabel = (
  value: VehiclePrestationsEnum
): string => {
  switch (value) {
    case VehiclePrestationsEnum.FREE_GARAGE_CHOICE:
      return $localize`Libre choix du garage`;
    case VehiclePrestationsEnum.REPLACEMENT_VEHICLE:
      return $localize`Véhicule de remplacement en cas de réparation`;
    case VehiclePrestationsEnum.PERSONAL_BELONGINGS:
      return $localize`Effets personnels`;
    case VehiclePrestationsEnum.PASSENGERS_PROTECTION:
      return $localize`Protection des occupants`;
    case VehiclePrestationsEnum.GROSS_NEGLIGENCE:
      return $localize`Renonciation de recours en cas de faute grave`;
    case VehiclePrestationsEnum.TROUBESHOOTING:
      return $localize`Dépannage`;
    case VehiclePrestationsEnum.GLASS_PROTECTION:
      return $localize`Couverture pour les phares`;
    case VehiclePrestationsEnum.TIRES:
      return $localize`Pneus & jantes`;
    case VehiclePrestationsEnum.PARKING_DAMAGE:
      return $localize`Dommage Parking`;
    default:
      return '';
  }
};

export enum VehicleRequestTypeEnum {
  NEW_IMATRICULATION = 'NEW_IMATRICULATION',
  VEHICLE_CHANGE = 'VEHICLE_CHANGE',
  COMPANY_CHANGE = 'COMPANY_CHANGE',
  OTHER = 'OTHER',
}

export const getVehicleRequestTypeLabel = (
  value: VehicleRequestTypeEnum
): string => {
  switch (value) {
    case VehicleRequestTypeEnum.NEW_IMATRICULATION:
      return $localize`Nouvelle immatriculation`;
    case VehicleRequestTypeEnum.VEHICLE_CHANGE:
      return $localize`Changement de véhicule`;
    case VehicleRequestTypeEnum.COMPANY_CHANGE:
      return $localize`Changement de compagnie`;
    case VehicleRequestTypeEnum.OTHER:
      return $localize`Autre`;
    default:
      return '';
  }
};

export enum VehicleUseEnum {
  PRIVATE = 'PRIVATE',
  PRIVATE_AND_BUSINESS = 'PRIVATE_AND_BUSINESS',
  BUSINESS = 'BUSINESS',
}

export const getVehicleUseLabel = (value: VehicleUseEnum): string => {
  switch (value) {
    case VehicleUseEnum.PRIVATE:
      return $localize`Privé`;
    case VehicleUseEnum.BUSINESS:
      return $localize`Professionnelle`;
    case VehicleUseEnum.PRIVATE_AND_BUSINESS:
      return $localize`Privé et trajets domicile-travail`;
    default:
      return '';
  }
};
